import { oc } from '@orpc/contract';
import { getTargetInputSchema, targetSchema } from '../schemas/targets.schemas.js';
export const getTargetContract = oc
    .route({
    method: 'GET',
    path: '/targets/{id}',
    tags: ['Targets'],
    summary: 'Get one target; 404 when none of its KPIs is visible to the caller',
})
    .input(getTargetInputSchema)
    .output(targetSchema);
//# sourceMappingURL=get-target.contract.js.map